const { NODE_ENV } = process.env;

export default () =>  NODE_ENV === "development"